// client/marks/text-align.ts
import { TextSelection } from "prosemirror-state";
import { MenuItemGroup } from "../types.js";
import { isInText, updateNodeAttrs } from "../util.js";
function toggleTextAlign(alignment) {
  return (state, dispatch) => {
    const { schema, selection } = state;
    const { $from, $to } = selection;
    let applicable = false;
    let transaction = state.tr;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
      if (node.type !== schema.nodes.paragraph && node.type !== schema.nodes.heading)
        return;
      if (node.attrs.textAlign === alignment)
        return;
      applicable = true;
      if (dispatch) {
        transaction = updateNodeAttrs(state, transaction, () => pos, { ...node.attrs, textAlign: alignment });
      }
    });
    if (dispatch) {
      const newSelection = TextSelection.create(transaction.doc, selection.from, selection.to);
      transaction = transaction.setSelection(newSelection);
      dispatch(transaction);
    }
    return applicable;
  };
}
function createTextAlignMenuItem(alignment) {
  const icon = `format_align_${alignment}`;
  const translation = {
    format_align_left: "Linksb\xFCndig",
    format_align_right: "Rechtsb\xFCndig",
    format_align_center: "Zentriert",
    format_align_justify: "Blocksatz"
  };
  return {
    group: MenuItemGroup.TEXT_ALIGNMENT,
    label: translation[icon],
    icon,
    isActive: (view) => {
      return !toggleTextAlign(alignment)(view.state);
    },
    run: (view) => {
      toggleTextAlign(alignment)(view.state, view.dispatch);
    },
    shouldVisualize: (view) => {
      return isInText(view.state);
    }
  };
}
export {
  createTextAlignMenuItem,
  toggleTextAlign
};
